import React from "react";
import {
  Card,
  FormLayout,
  Layout,
  PageActions,
  SkeletonBodyText,
  SkeletonDisplayText,
} from "@shopify/polaris";

export default function TagsFormSkeleton({ primaryAction, secondaryActions }) {
  return (
    <Layout>
      <Layout.Section>
        <Card sectioned>
          <FormLayout>
            <SkeletonDisplayText />
            <SkeletonBodyText lines={2} />
            <SkeletonDisplayText />
            <SkeletonBodyText lines={4} />
          </FormLayout>
        </Card>
        <Card sectioned>
          <FormLayout>
            <SkeletonDisplayText />
            <SkeletonBodyText />
          </FormLayout>
        </Card>
      </Layout.Section>
      <Layout.Section secondary>
        <Card sectioned>
          <FormLayout>
            <SkeletonDisplayText />
            <SkeletonBodyText lines={1} />
          </FormLayout>
        </Card>
        <Card sectioned>
          <FormLayout>
            <SkeletonDisplayText />
            <SkeletonBodyText lines={2} />
          </FormLayout>
        </Card>
      </Layout.Section>
      <Layout.Section>
        {(primaryAction || secondaryActions) && (
          <PageActions
            primaryAction={primaryAction}
            secondaryActions={secondaryActions}
          />
        )}
      </Layout.Section>
    </Layout>
  );
}
